import { Navigate } from "react-router-dom";

/** `app/dashboard/page.tsx` redirected to the orders tab. */
export function DashboardHomePage() {
  return <Navigate to="/dashboard/orders" replace />;
}
